import React, { ReactNode } from "react";
import MesProjetsHeader from "./MyProjectsHeader";

interface ProjetPageProps {
  children: ReactNode;
}

const ProjetPage: React.FC<ProjetPageProps> = ({ children }) => {
  return (
    <div className="gap-y-5	">
      <MesProjetsHeader />
      <main className="flex-grow">{children}</main>
    </div>
  );
};

export default ProjetPage;
